import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Typography, TextField, Button, MenuItem, Alert } from '@mui/material';
import fascicoloApi from '../../api/fascicoloApi';
import BackButtonDesktop from '../../components/BackButtonDesktop';

export default function RichiestaCreatePage() {
  const { fascicoloId } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    fascicoloId: fascicoloId,
    tipoDocumento: '',
    descrizione: ''
  });

  const [contribuenteId, setContribuenteId] = useState(null);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const tipiDocumento = [
    'DOCUMENTO_IDENTITA',
    'CONTRATTO',
    'UNICO',
    'MULTA',
    'PAGOPA',
    'ATTO_SOCIETARIO',
    'BANCARIO',
    'RATEIZZAZIONE_ADE',
    'ROTTAMAZIONE',
    'AMA',
    'ACCERTAMENTO_TARI',
    'F24',
    'FF24PREDETERMINATO',
    'TARI',
    'INTIMAZIONEPAG_AGRISC',
    'BOLLOAUTO',
    'INARCASSA',
    'ALTRO'
  ];

  useEffect(() => {
    fascicoloApi.getFascicoloById(fascicoloId)
      .then(res => setContribuenteId(res.data.contribuenteId))
      .catch(() => setError('Errore nel recupero del fascicolo'));
  }, [fascicoloId]);

  const handleSubmit = async () => {
    if (!form.tipoDocumento) {
      setError('Selezionare il tipo di documento');
      return;
    }

    setSaving(true);
    setError('');

    try {
      await fascicoloApi.createrequest(form);
      navigate(`/contribuente/${contribuenteId}/fascicolo`);
    } catch (err) {
      const msg =
        typeof err.response?.data === 'string'
          ? err.response.data
          : err.response?.data?.error || 'Errore durante la creazione della richiesta';
      setError(msg);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
    <BackButtonDesktop />
      <Typography variant="h5" sx={{ mb: 3 }}>
        Crea nuova richiesta documento
      </Typography>

      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      <TextField
        select
        label="Tipo Documento"
        value={form.tipoDocumento}
        onChange={e => setForm({ ...form, tipoDocumento: e.target.value })}
        fullWidth
        sx={{ mb: 2 }}
      >
        {tipiDocumento.map(t => (
          <MenuItem key={t} value={t}>{t}</MenuItem>
        ))}
      </TextField>

      <TextField
        label="Descrizione"
        value={form.descrizione}
        onChange={e => setForm({ ...form, descrizione: e.target.value })}
        fullWidth
        multiline
        rows={3}
        sx={{ mb: 2 }}
      />

      <Button
        variant="contained"
        onClick={handleSubmit}
        disabled={saving}
        fullWidth
      >
        {saving ? 'Salvando...' : 'Crea Richiesta'}
      </Button>
    </Container>
  );
}
